var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wallet_svg__clip0_61530_7438)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 12.75h-1.5v1.5H18v-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6H3V3.75h16.5v-1.5H3a1.5 1.5 0 00-1.5 1.5V19.5A1.5 1.5 0 003 21h18a1.5 1.5 0 001.5-1.5v-12A1.5 1.5 0 0021 6zM3 19.5v-12h18v2.25h-6a1.5 1.5 0 00-1.5 1.5v4.5a1.5 1.5 0 001.5 1.5h6v2.25H3zm18-8.25v4.5h-6v-4.5h6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wallet_svg__clip0_61530_7438"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgWallet;